module.exports = __webpack_public_path__ + "img/bell-icon.b73c8b4a.svg";